export { default } from "./HeroSlim";
export * from "./HeroSlim";
export * from "./HeroSlim.model";
